import { langFilesToLoad } from "../../common/functions/helper.ts/langFilesToLoad";

export var assetsToLoad: Array<Array<string>> = [];

assetsToLoad.push(["gameDefaultImages", "images/gameDefault.json"]);

assetsToLoad.push([
  "extraBonusWinEffects1",
  "images/extraBonusWinEffects-0.json",
]); //new FX
assetsToLoad.push([
  "extraBonusWinEffects2",
  "images/extraBonusWinEffects-1.json",
]); //new FX

assetsToLoad.push(["coins", "images/coins.json"]);
assetsToLoad.push(["gamblecards", "images/gambleCards.json"]);

assetsToLoad.push(["newImagesMsg", "images/messagePopupv2.json"]); //--messagev2
assetsToLoad.push(["jackpotExplosion", "images/jackpotExplosion.json"]);
assetsToLoad.push(["bgGradients", "images/bgGradients.json"]);
assetsToLoad.push(["lettersAndNumbers", "images/lettersandnumbers.json"]);

assetsToLoad.push(["animatedBtn", "images/animatedBtn.json"]);
assetsToLoad.push(["bgElem", "images/bgElements.json"]);
// assetsToLoad.push(['bigFrameFire',"images/fireFrame.json"])
// assetsToLoad.push(['blurredDices',"images/blurredDices.json"])

assetsToLoad.push(["gameLogos", "images/gameLogo.json"]);
assetsToLoad.push(["jackpot", "images/jackpot.json"]);
assetsToLoad.push(["jackpotFX", "images/jackpotFX.json"]);
assetsToLoad.push(["starDiceDeluxe", "images/starDiceDeluxe.json"]);
// assetsToLoad.push(['winframeAnimation',"images/winframeAnimation.json"])
assetsToLoad.push(["winlines_lines", "images/winlineAnimation.json"]);

// Christmas

assetsToLoad.push(["frameWinAnimated", "images/frameWin.json"]); //new WinFrameAnimation;
assetsToLoad.push(["sergio", "images/sergioAnimations-0.json"]); //new WinFrameAnimation;
assetsToLoad.push(["sergio1", "images/sergioAnimations-1.json"]); //new WinFrameAnimation;
assetsToLoad.push(["santaHD", "images/santaHD.json"]); //new WinFrameAnimation;
assetsToLoad.push(["fireDrop", "images/fireDrop.json"]); //new FX
assetsToLoad.push(["fx_zoom", "images/winFx.json"]); //new FX

//-SergioGame

assetsToLoad.push(["gameSymbols", "images/GameSymbols-0.json"]);
assetsToLoad.push(["gameSymbols1", "images/GameSymbols-1.json"]);
assetsToLoad.push(["gameSymbols2", "images/GameSymbols-2.json"]);
assetsToLoad.push(["concertStageBG", "images/bgStageGold.json"]);

//-gamble game mod

assetsToLoad.push(["gambleNewStyle", "images/gambleGameRestyle.json"]);
//-win anim
assetsToLoad.push(["sswave", "images/shockWaveWin.json"]);
assetsToLoad.push(["ssdance", "images/sergioVideo-0.json"]);
assetsToLoad.push(["ssdance2", "images/sergioVideo-1.json"]);
assetsToLoad.push(["messageBox", "images/messageBox.json"]);
//-

assetsToLoad.push(["bonusGameInterface", "images/bonusGameInterface.json"]);

//tournamentImages and text
assetsToLoad.push(["tournament1", "images/tournament_lowCompressed.json"]); //new FX

//-load the lang texts
for (let i = 0; i < langFilesToLoad.length; i++) {
  assetsToLoad.push(langFilesToLoad[i]);
}
